import React from "react";
var __jsx = React.createElement;
import VariantTwo from "@/pages/checkout/pre-checkout/variants/VariantTwo";
import FinanceModal from "@/pages/checkout/pre-checkout/PurchaseMethods/FinanceModal";
import { useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
var PurchaseMethods = function PurchaseMethods() {
  var _useCheckoutOrder$sta = useCheckoutOrder().state,
    financeModal = _useCheckoutOrder$sta.financeModal,
    checkoutOrder = _useCheckoutOrder$sta.checkoutOrder;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(VariantTwo, null), /*#__PURE__*/React.createElement(FinanceModal, {
    isOpen: financeModal.value,
    onClose: financeModal.setFalse,
    isNew: !!(checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.post_is_new),
    postId: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_id,
    financeSteps: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.financeSteps,
    g4Data: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.g4_data_layer
  }));
};
export default PurchaseMethods;